const guideGen5 = [
  "Avenitia – Starter-Pokémon erhalten",
  "Route 1 – Erstes wildes Pokémon",
  "Septerna City – 1. Arena (Normal – Aloé)",
  "Traumbogen – erstes Galaktik-Event",
  "Route 3 – Kindergarten und Trainerkämpfe",
  "Stadt der Farben – 2. Arena (Gift – Artie)",
  "Wald von Ewigenwald durchqueren",
  "Route 4 – Sandsturmgebiet",
  "Wüste & Wüstenresort – optionales Training",
  "Stratos City – 3. Arena (Elektro – Kamilla)",
  "Route 5 & 16 – Begegnung mit Team Plasma",
  "Marea City – 4. Arena (Boden – Turner)",
  "Frachtlager & P2-Labor – Team Plasma",
  "Route 6 – nach Twindrake City",
  "Turm des Himmels – Story & Training",
  "Twindrake City – 5. Arena (Flug – Lilia/Sandro)",
  "Route 7 & Celestial Tower",
  "Route 8 – Moor von Nevaio City",
  "Nevaio City – 6. Arena (Eis – Brycen)",
  "Eistunnel & Team Plasma-Event",
  "Route 9 & Pokémon League Zugang",
  "Ondula – Story mit G-Cis beginnt",
  "Riesengrotte – N & Zekrom/Reshiram",
  "Pokémon Liga – 7. Arena (Unlicht – G-Cis)",
  "Team Plasma Schloss – Finale gegen N",
  "Nach dem Champ-Kampf – Credits",
  "Nachspiel: Route 11–15 & Siegesstraße",
  "Zugang zu Schwarzer Stadt / Weißer Wald",
  "Route 17 & 18 – Optionales Gebiet",
  "Kampf gegen Champ Lauro im Nachspiel",
];

export default guideGen5;
